import { DateTime } from 'luxon';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useBoolean from '../../hooks/useBoolean';
import { selectSelectedLanguage } from '../../pages/store/language/selectors';
import DataLoadingWrapper from '../common/DataLoadingWrapper';

const Timer = ({ locale }: { locale: string }) => {
  const getDate = useCallback(
    () =>
      DateTime.now().toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS, {
        locale,
      }),
    [locale]
  );
  const [date, setDate] = useState<string>(getDate());

  useMemo(() => setInterval(() => setDate(getDate()), 1000), [getDate]);

  return <p className="text-sm m-0">{date}</p>;
};

const Clock = () => {
  const selectedLanguage = useSelector(selectSelectedLanguage);
  const [loading, { setFalse: hideLoder, setTrue: showLoader }] =
    useBoolean(true);

  useEffect(() => {
    setTimeout(() => {
      hideLoder();
    }, 1500);
  }, [hideLoder, selectedLanguage, showLoader]);

  return (
    <DataLoadingWrapper
      loadingData={loading}
      customLoader={
        <div className="animate-pulse w-[250px]">
          <div className="h-[20px] bg-gray-300 w-full mb-1" />
        </div>
      }
    >
      <Timer
        locale={selectedLanguage.language.toLowerCase()}
        key={selectedLanguage.language.toLowerCase()}
      />
    </DataLoadingWrapper>
  );
};

export default Clock;
